<!-- eslint-disable max-len -->
<template>
  <div class="certificateContents">
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 792 612"
      enable-background="new 0 0 792 612"
      xml:space="preserve"
    >
      <g id="certificate">
        <path id="bg" fill="#FFFFFF" d="M792.1,612.6V0.6H0.1v612H792.1z" />
        <path
          fill="#66C0BE"
          d="M396.1,125.3c-10.9,0-21.3,2.1-31.3,6.3c-9.6,4.1-18.1,9.8-25.6,17.2c-7.4,7.4-13.2,16-17.2,25.6
          c-4.2,10-6.3,20.4-6.3,31.3c0,10.9,2.1,21.3,6.3,31.3c4.1,9.6,9.8,18.1,17.2,25.6c7.4,7.4,16,13.2,25.6,17.2
          c10,4.2,20.4,6.3,31.3,6.3s21.3-2.1,31.3-6.3c9.6-4.1,18.2-9.8,25.6-17.2c7.4-7.4,13.2-15.9,17.2-25.6c4.2-10,6.3-20.4,6.3-31.3
          c0-10.9-2.1-21.4-6.3-31.3c-4.1-9.6-9.8-18.2-17.2-25.6c-7.4-7.4-16-13.2-25.6-17.2C417.4,127.4,407,125.3,396.1,125.3z"
        />
        <g>
          <path
            id="Cert_Certificate_0_Layer3_0_1_STROKES"
            fill="none"
            stroke="#231F20"
            d="M96.6,508.6H288"
          />
        </g>
        <rect x="100" y="510.3" fill="none" width="68.6" height="22.2" />
        <text
          transform="matrix(1 0 0 1 101.95 524.8409)"
          fill="#231F20"
          font-family="'ArialMT'"
          font-size="12px"
        >Awarded by</text>
        <g>
          <path
            id="Cert_Certificate_0_Layer3_2_MEMBER_0_1_STROKES"
            fill="none"
            stroke="#231F20"
            d="M512.8,508.6h191.4"
          />
        </g>
        <rect x="671.9" y="510.3" fill="none" width="29.5" height="22.2" />
        <text
          transform="matrix(1 0 0 1 673.9 524.8409)"
          fill="#231F20"
          font-family="'ArialMT'"
          font-size="12px"
        >Date</text>
        <rect
          x="302"
          y="121"
          transform="matrix(0.6029 -0.7979 0.7979 0.6029 10.1117 307.3148)"
          fill="none"
          width="23.5"
          height="45"
        />

        <rect
          x="316.2"
          y="107.6"
          transform="matrix(0.733 -0.6802 0.6802 0.733 -1.5307 256.3954)"
          fill="none"
          width="19.3"
          height="45"
        />

        <rect
          x="328.6"
          y="98.1"
          transform="matrix(0.8254 -0.5646 0.5646 0.8254 -9.0862 211.7864)"
          fill="none"
          width="18.4"
          height="45"
        />

        <rect
          x="341.3"
          y="90.3"
          transform="matrix(0.8986 -0.4388 0.4388 0.8986 -13.8899 165.5668)"
          fill="none"
          width="19.8"
          height="45"
        />

        <rect
          x="356.4"
          y="85.5"
          transform="matrix(0.9447 -0.3281 0.3281 0.9447 -15.3386 125.0728)"
          fill="none"
          width="13.2"
          height="45"
        />

        <rect
          x="365.3"
          y="82.2"
          transform="matrix(0.977 -0.2133 0.2133 0.977 -13.6906 82.4491)"
          fill="none"
          width="19.7"
          height="44.9"
        />

        <rect
          x="381.1"
          y="80.4"
          transform="matrix(0.9954 -9.542979e-02 9.542979e-02 0.9954 -8.0478 37.4731)"
          fill="none"
          width="13.3"
          height="44.9"
        />

        <rect
          x="377.2"
          y="93.7"
          transform="matrix(2.456673e-02 -0.9997 0.9997 2.456673e-02 287.2512 499.659)"
          fill="none"
          width="44.9"
          height="17.9"
        />

        <rect
          x="387.3"
          y="98.4"
          transform="matrix(0.1214 -0.9926 0.9926 0.1214 257.3343 497.7635)"
          fill="none"
          width="45"
          height="10.3"
        />

        <rect
          x="398.3"
          y="95.7"
          transform="matrix(0.2421 -0.9702 0.9702 0.2421 216.5328 488.2862)"
          fill="none"
          width="45"
          height="19.7"
        />

        <rect
          x="410.6"
          y="102.6"
          transform="matrix(0.3608 -0.9326 0.9326 0.3608 174.8604 473.7417)"
          fill="none"
          width="45"
          height="13.3"
        />

        <rect
          x="418"
          y="106.9"
          transform="matrix(0.4302 -0.9027 0.9027 0.4302 149.3951 461.7953)"
          fill="none"
          width="45"
          height="11.2"
        />

        <rect
          x="428"
          y="108.3"
          transform="matrix(0.5192 -0.8547 0.8547 0.5192 115.7564 441.7438)"
          fill="none"
          width="45"
          height="19.3"
        />

        <rect
          x="440.3"
          y="117.9"
          transform="matrix(0.6423 -0.7664 0.7664 0.6423 68.1554 400.1616)"
          fill="none"
          width="44.9"
          height="18.4"
        />

        <rect
          x="449.7"
          y="128.5"
          transform="matrix(0.733 -0.6802 0.6802 0.733 33.5534 357.4866)"
          fill="none"
          width="45"
          height="14.9"
        />

        <rect
          x="456.2"
          y="137.2"
          transform="matrix(0.7967 -0.6044 0.6044 0.7967 10.397 318.578)"
          fill="none"
          width="45"
          height="13.3"
        />
        <path
          fill="#231F20"
          d="M318.1,139.1l2.1-1.7c1.4,1.7,2,3.4,2.1,5.2c0,1.8-0.5,3.5-1.8,5.1c-1.3,1.7-2.6,2.8-4.1,3.3
          c-1.5,0.5-3,0.6-4.7,0.2c-1.7-0.4-3.3-1.2-4.7-2.3c-1.6-1.2-2.8-2.6-3.5-4.1c-0.7-1.5-1-3.1-0.7-4.7c0.2-1.6,0.9-3.1,1.9-4.4
          c1.2-1.5,2.5-2.5,4.1-3c1.6-0.5,3.2-0.4,5,0.3l-1,2.4c-1.4-0.5-2.6-0.6-3.6-0.3c-1,0.3-1.9,1-2.7,2c-0.9,1.2-1.4,2.4-1.4,3.6
          c0,1.2,0.3,2.4,1,3.4c0.7,1,1.6,2,2.6,2.7c1.3,1,2.6,1.7,3.9,2c1.3,0.4,2.4,0.3,3.5-0.1s2-1.1,2.7-2.1c0.9-1.1,1.3-2.4,1.2-3.6
          C319.7,141.7,319.2,140.4,318.1,139.1z"
        />
        <path
          fill="#231F20"
          d="M321.3,135.2c-1.8-1.9-2.5-3.8-2.3-5.7c0.2-1.6,0.9-3,2.2-4.1c1.4-1.3,3-1.9,4.7-1.8c1.8,0.1,3.4,1,4.9,2.6
          c1.2,1.3,2,2.5,2.3,3.7c0.3,1.1,0.3,2.2-0.1,3.4c-0.4,1.1-1,2.1-1.9,2.9c-1.4,1.3-3,2-4.8,1.9S322.9,136.9,321.3,135.2z
           M323.1,133.5c1.2,1.3,2.4,2,3.6,2.2c1.2,0.1,2.2-0.2,3.1-1c0.9-0.8,1.3-1.8,1.2-3c0-1.2-0.7-2.5-1.9-3.8c-1.2-1.3-2.4-2-3.5-2.1
          c-1.2-0.1-2.2,0.2-3.1,1c-0.9,0.8-1.3,1.8-1.3,3C321.3,131,321.9,132.2,323.1,133.5z"
        />
        <path
          fill="#231F20"
          d="M337.6,129.9l-7.9-11.6l1.8-1.2l1.1,1.6c0-1.8,0.8-3.3,2.4-4.4c0.7-0.5,1.4-0.8,2.2-0.9
          c0.8-0.1,1.4-0.1,2,0.1c0.6,0.2,1.1,0.6,1.6,1c0.3,0.3,0.8,0.9,1.4,1.8l4.9,7.1l-2,1.3l-4.8-7c-0.5-0.8-1-1.3-1.5-1.6
          c-0.4-0.3-0.9-0.4-1.5-0.4c-0.5,0-1.1,0.2-1.6,0.6c-0.8,0.6-1.4,1.3-1.6,2.3c-0.2,0.9,0.1,2.2,1.2,3.6l4.3,6.3L337.6,129.9z"
        />
        <path
          fill="#231F20"
          d="M349.2,123.6l2.2-0.7c0.4,0.6,0.9,0.9,1.4,1c0.7,0.1,1.5,0,2.5-0.5c1-0.5,1.7-1.1,2-1.7
          c0.3-0.7,0.4-1.4,0.3-2.2c-0.1-0.5-0.5-1.4-1.2-2.8c-0.4,1.6-1.3,2.7-2.7,3.3c-1.7,0.8-3.4,0.9-4.9,0.1s-2.8-2-3.6-3.8
          c-0.6-1.2-0.9-2.4-1-3.6c-0.1-1.2,0.2-2.3,0.7-3.3s1.4-1.7,2.5-2.2c1.5-0.7,3-0.7,4.6,0l-0.7-1.5l2-1l5.3,10.9c1,2,1.4,3.4,1.4,4.5
          c0,1-0.3,2-1,2.9c-0.6,0.9-1.6,1.7-2.8,2.3c-1.5,0.7-2.9,1-4.1,0.8C350.8,125.8,349.8,125,349.2,123.6z M347.3,115.2
          c0.8,1.7,1.7,2.7,2.7,3.1c1,0.4,2,0.4,3-0.1c1-0.5,1.6-1.3,1.9-2.3s0-2.4-0.7-4c-0.8-1.5-1.7-2.5-2.7-3c-1.1-0.4-2.1-0.4-3,0
          c-0.9,0.5-1.6,1.2-1.9,2.3C346.3,112.4,346.5,113.7,347.3,115.2z"
        />
        <path
          fill="#231F20"
          d="M362.8,116.1l-4.6-13.2l2-0.7l0.7,2c0.2-1.1,0.5-1.9,0.8-2.3s0.8-0.8,1.3-0.9c0.8-0.3,1.6-0.3,2.6-0.1
          l-0.1,2.3c-0.7-0.1-1.3-0.1-1.8,0.1c-0.5,0.2-0.9,0.5-1.2,0.9c-0.3,0.4-0.4,0.9-0.4,1.5c0,0.9,0.2,1.8,0.5,2.7l2.4,6.9L362.8,116.1
          z"
        />
        <path
          fill="#231F20"
          d="M379.4,109.7c-0.7,0.9-1.4,1.6-2.1,2.1c-0.7,0.5-1.5,0.8-2.5,1c-1.5,0.3-2.7,0.2-3.7-0.3s-1.6-1.4-1.8-2.5
          c-0.1-0.7-0.1-1.3,0.1-1.9s0.5-1.2,0.9-1.6c0.4-0.4,0.9-0.8,1.5-1.1c0.4-0.2,1.1-0.5,2-0.8c1.8-0.6,3.1-1.2,4-1.7
          c-0.1-0.3-0.1-0.5-0.1-0.6c-0.2-0.9-0.6-1.6-1.1-1.9c-0.7-0.4-1.6-0.5-2.8-0.2c-1.1,0.2-1.9,0.6-2.3,1.1c-0.4,0.5-0.7,1.3-0.7,2.3
          l-2.3,0.2c0-1,0.2-1.9,0.5-2.6c0.3-0.7,0.9-1.3,1.7-1.8c0.8-0.5,1.8-0.9,3-1.2c1.2-0.3,2.1-0.3,2.9-0.2c0.8,0.1,1.4,0.3,1.8,0.7
          c0.4,0.3,0.8,0.8,1.1,1.4c0.2,0.4,0.4,1.1,0.6,2.1l0.7,3.1c0.5,2.2,0.8,3.5,1,4c0.2,0.5,0.5,1.1,0.9,1.5l-2.4,0.5
          C379.9,110.9,379.6,110.4,379.4,109.7z M378.1,104.6c-0.8,0.5-2,1.1-3.6,1.7c-0.9,0.3-1.6,0.6-1.9,0.9c-0.4,0.3-0.6,0.6-0.7,1
          c-0.1,0.4-0.2,0.8-0.1,1.2c0.1,0.6,0.5,1.1,1,1.4s1.3,0.4,2.2,0.2c0.9-0.2,1.6-0.6,2.3-1.1c0.6-0.5,1-1.2,1.2-1.9
          c0.1-0.6,0.1-1.4-0.1-2.4L378.1,104.6z"
        />
        <path
          fill="#231F20"
          d="M390.5,108.1l0.5,2c-0.6,0.2-1.2,0.3-1.8,0.4c-0.9,0.1-1.5,0-2-0.2c-0.5-0.2-0.9-0.5-1.1-1
          c-0.2-0.4-0.4-1.3-0.6-2.8l-0.8-8l-1.7,0.2l-0.2-1.8l1.7-0.2l-0.3-3.4l2.2-1.6l0.5,4.9l2.4-0.2l0.2,1.8l-2.4,0.2l0.8,8.1
          c0.1,0.7,0.1,1.1,0.2,1.3c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.5,0.1,0.8,0.1C389.8,108.3,390.1,108.2,390.5,108.1z"
        />
        <path
          fill="#231F20"
          d="M403.4,110.3l0.1-2.1c-1.1,1.6-2.6,2.3-4.5,2.3c-0.8,0-1.6-0.2-2.3-0.5c-0.7-0.3-1.2-0.7-1.6-1.2
          c-0.3-0.5-0.6-1.1-0.7-1.8c-0.1-0.5-0.1-1.2-0.1-2.2l0.2-8.7l2.4,0.1l-0.2,7.7c0,1.2,0,2.1,0.1,2.5c0.1,0.6,0.4,1.1,0.9,1.5
          c0.5,0.4,1.1,0.6,1.8,0.6c0.7,0,1.4-0.1,2-0.5c0.6-0.3,1.1-0.8,1.4-1.5c0.3-0.6,0.4-1.5,0.5-2.7l0.2-7.5l2.4,0.1l-0.3,14
          L403.4,110.3z"
        />
        <path fill="#231F20" d="M407.5,110.9l2.3-19.2l2.4,0.3l-2.3,19.2L407.5,110.9z" />
        <path
          fill="#231F20"
          d="M422.4,112c-1,0.5-2,0.8-2.8,0.9c-0.9,0.1-1.7,0-2.7-0.2c-1.5-0.4-2.5-1-3.2-2c-0.6-0.9-0.8-2-0.5-3.1
          c0.2-0.7,0.5-1.2,0.9-1.7c0.4-0.5,0.9-0.8,1.5-1s1.2-0.3,1.8-0.3c0.5,0,1.2,0,2.1,0.2c1.9,0.2,3.3,0.3,4.3,0.2
          c0.1-0.3,0.1-0.5,0.2-0.6c0.2-0.9,0.2-1.7-0.2-2.1c-0.5-0.7-1.3-1.1-2.4-1.4c-1.1-0.3-1.9-0.3-2.5,0c-0.6,0.3-1.2,0.8-1.6,1.7
          l-2.2-0.9c0.4-0.9,1-1.6,1.6-2.1c0.6-0.5,1.4-0.8,2.4-0.9c1-0.1,2,0,3.2,0.3c1.2,0.3,2.1,0.7,2.7,1.1c0.7,0.5,1.1,0.9,1.3,1.4
          c0.2,0.5,0.3,1.1,0.3,1.7c0,0.4-0.2,1.1-0.4,2.2l-0.8,3.1c-0.5,2.1-0.8,3.5-0.9,4.1s0,1.2,0.2,1.8l-2.4-0.6
          C422.3,113.2,422.3,112.6,422.4,112z M423.4,106.8c-0.9,0.1-2.2,0.1-4-0.1c-1-0.1-1.7-0.1-2.1,0c-0.4,0.1-0.8,0.2-1.1,0.5
          c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.6,0,1.2,0.3,1.7c0.4,0.5,1,0.9,1.9,1.1c0.9,0.2,1.7,0.2,2.5,0c0.8-0.2,1.4-0.6,1.9-1.2
          c0.4-0.5,0.7-1.2,0.9-2.2L423.4,106.8z"
        />
        <path
          fill="#231F20"
          d="M433.2,115.2l-0.4,2.1c-0.7-0.1-1.3-0.3-1.7-0.5c-0.8-0.3-1.4-0.7-1.7-1.1c-0.3-0.4-0.5-0.9-0.5-1.4
          c0-0.5,0.2-1.4,0.7-2.7l2.9-7.5l-1.6-0.6l0.7-1.7l1.6,0.6l1.3-3.2l2.7-0.5l-1.8,4.6l2.2,0.9l-0.7,1.7l-2.2-0.9l-3,7.6
          c-0.2,0.6-0.4,1.1-0.4,1.3c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.4,0.3,0.7,0.5C432.5,115,432.8,115.1,433.2,115.2z"
        />
        <path
          fill="#231F20"
          d="M435.6,118.6l6-12.6l2.1,1l-6,12.6L435.6,118.6z M442.7,103.6l1.2-2.5l2.1,1l-1.2,2.5L442.7,103.6z"
        />
        <path
          fill="#231F20"
          d="M444.4,115c1.3-2.2,3-3.5,4.8-3.8c1.6-0.3,3.1,0.1,4.6,1c1.6,1,2.7,2.4,3.1,4.1c0.4,1.7,0,3.5-1.1,5.4
          c-0.9,1.5-1.9,2.6-2.9,3.2c-1,0.6-2.1,0.9-3.3,0.8c-1.2,0-2.3-0.4-3.3-1c-1.7-1-2.7-2.4-3.1-4.1C442.7,118.9,443.1,117,444.4,115z
           M446.4,116.3c-0.9,1.5-1.3,2.9-1.1,4.1c0.2,1.2,0.8,2.1,1.8,2.7c1,0.6,2.1,0.7,3.2,0.4c1.1-0.4,2.2-1.3,3.1-2.9
          c0.9-1.5,1.2-2.8,1-4c-0.2-1.2-0.8-2.1-1.8-2.7c-1-0.6-2.1-0.7-3.2-0.4S447.4,114.7,446.4,116.3z"
        />
        <path
          fill="#231F20"
          d="M453.8,129.4l9-10.7l1.6,1.4l-1.3,1.5c1.8-0.5,3.4-0.2,4.9,1.1c0.6,0.5,1.1,1.2,1.5,1.8
          c0.3,0.7,0.5,1.3,0.5,1.9c0,0.6-0.2,1.2-0.6,1.8c-0.2,0.4-0.7,1-1.4,1.8l-5.5,6.6l-1.8-1.5l5.5-6.5c0.6-0.7,1-1.4,1.2-1.8
          c0.2-0.5,0.2-1,0-1.5c-0.2-0.5-0.5-1-1-1.4c-0.8-0.6-1.6-1-2.6-0.9c-1,0-2,0.7-3.2,2.1l-4.9,5.9L453.8,129.4z"
        />
        <path
          fill="#231F20"
          d="M466.5,134.9l1.9,1.5c-0.6,0.7-0.9,1.5-0.8,2.3c0,0.8,0.4,1.6,1.2,2.4c0.7,0.8,1.5,1.2,2.1,1.3
          c0.7,0.1,1.2-0.1,1.7-0.5c0.4-0.4,0.5-0.8,0.5-1.4c-0.1-0.4-0.4-1.2-1.1-2.3c-0.9-1.6-1.4-2.7-1.6-3.4c-0.2-0.7-0.2-1.4-0.1-2
          s0.5-1.2,1-1.7c0.5-0.4,1-0.7,1.6-0.9c0.6-0.2,1.2-0.2,1.8,0c0.5,0.1,1,0.3,1.5,0.6c0.6,0.3,1.1,0.8,1.6,1.3
          c0.7,0.8,1.3,1.6,1.6,2.4c0.3,0.8,0.4,1.6,0.3,2.2c-0.1,0.7-0.5,1.3-1,2.1l-1.8-1.5c0.5-0.6,0.7-1.2,0.6-1.8c0-0.6-0.4-1.3-1-2
          c-0.7-0.8-1.4-1.2-2-1.3c-0.6-0.1-1,0-1.4,0.3c-0.2,0.2-0.4,0.5-0.4,0.8c-0.1,0.3,0,0.7,0.2,1.1c0.1,0.2,0.4,0.9,1,1.9
          c0.8,1.5,1.3,2.6,1.6,3.3s0.3,1.3,0.2,2c-0.1,0.6-0.5,1.2-1.1,1.8c-0.6,0.5-1.3,0.9-2.1,1c-0.8,0.1-1.7,0-2.5-0.4
          c-0.9-0.4-1.7-1-2.4-1.8c-1.2-1.3-1.9-2.6-2-3.8C465.2,137.3,465.6,136.1,466.5,134.9z"
        />
        <path
          fill="#231F20"
          d="M473.7,149l2.2-1.6l1.6,2.2l-2.2,1.6L473.7,149z M477.9,146.6l7.7-6.8l3.4-2.6l1.8,2.3l-3.4,2.6l-8.6,5.6
          L477.9,146.6z"
        />
        <g>
          <path
            id="Cert_Certificate_0_Layer3_4_1_STROKES"
            fill="none"
            stroke="#231F20"
            stroke-width="12"
            d="M396.1,286.2
            c10.9,0,21.3-2.1,31.3-6.3c9.6-4.1,18.2-9.8,25.6-17.2c7.4-7.4,13.2-15.9,17.2-25.6c4.2-10,6.3-20.4,6.3-31.3
            c0-10.9-2.1-21.4-6.3-31.3c-4.1-9.6-9.8-18.2-17.2-25.6c-7.4-7.4-16-13.2-25.6-17.2c-10-4.2-20.4-6.3-31.3-6.3
            c-10.9,0-21.3,2.1-31.3,6.3c-9.6,4.1-18.1,9.8-25.6,17.2c-7.4,7.4-13.2,16-17.2,25.6c-4.2,10-6.3,20.4-6.3,31.3
            c0,10.9,2.1,21.3,6.3,31.3c4.1,9.6,9.8,18.1,17.2,25.6c7.4,7.4,16,13.2,25.6,17.2C374.8,284.1,385.2,286.2,396.1,286.2z"
          />
        </g>
        <defs>
          <filter
            id="Adobe_OpacityMaskFilter"
            filterUnits="userSpaceOnUse"
            x="307.8"
            y="149.9"
            width="145.1"
            height="131.3"
          >
            <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
          </filter>
        </defs>
        <mask
          maskUnits="userSpaceOnUse"
          x="307.8"
          y="149.9"
          width="145.1"
          height="131.3"
          id="Mask_Mask_19_2_"
        >
          <g transform="matrix( 1, 0, 0, 1, 0,0) " filter="url(#Adobe_OpacityMaskFilter)">
            <g>
              <g id="Mask_Cert_CAPTAIN_KEYBOARD_0_2_MASK_0_FILL_2_">
                <path fill="#FFFFFF" d="M455.2,142.6l-148.1,5.2l5,141.8l148.1-5.1L455.2,142.6z" />
              </g>
            </g>
          </g>
        </mask>
        <g mask="url(#Mask_Mask_19_2_)">
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_0_FILL">
                <path
                  fill="#231F20"
                  d="M445.8,161.6l-0.5,0.3c-7.9,5-17.6,4.9-29.1-0.3c-3.6-1.6-7.2-3.7-10.7-6.1l-4.2-3.2
                  c-4.7-3.1-11.4-3.2-20-0.4c-2.7,0.9-5.4,2-8.2,3.4l-3.3,1.8c-5.8,2.8-13,3.6-21.6,2.4c-2.7-0.4-5.4-0.9-8-1.7l-3.2-0.9
                  c-8.4-1.1-15.8-0.2-22.1,2.6c-3.2,1.4-5.5,2.9-7,4.6c2.9-0.3,6.3,0.1,10.1,1.2c7.7,2.2,13.9,6.8,18.5,13.9
                  c6.3,9.5,15.8,18.7,28.6,27.4c6.4,4.4,12.2,7.8,17.3,10.2l2.6-1.8c1.6-1.5,1.6-2.4,0-2.9l-2.8-0.2l-0.2-5.6l-4.9-1.6l28.6-13.8
                  l25.9,11l-3.6,6.3c-3.2,1.9-3.8,3.1-1.8,3.7c1,0.3,2.4,0.3,4.1,0.2L445.8,161.6z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_2_FILL">
                <path
                  fill="#FFFFFF"
                  d="M431.5,237.7l-1.7-31.9l-47.9,1.8l1.9,38.4l0.7,1.9c1,1.2,2.8,1.8,5.5,1.8l33.8-1.2
                  c1.4-0.3,2.8-1.1,4.1-2.2C430.5,244.3,431.7,241.4,431.5,237.7z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_3_FILL">
                <path
                  fill="#BDBEC0"
                  d="M376.7,206.9c0-0.3-0.1-0.4-0.2-0.1C376.3,207,376.4,207.1,376.7,206.9 M428.3,201.3
                  c-0.6-0.3-1.2-0.6-1.9-0.8c-0.7-0.2-1.3-0.4-1.9-0.8c-1.7-0.9-2.9-1.5-3.6-1.9c-1.3-0.4-2.5-0.9-3.8-1.4l-3.8-1.5
                  c-1.2-0.6-2.5-1.1-3.8-1.6c-0.5-0.2-1.1-0.6-1.8-1.3c-0.5-0.5-1.2-0.7-2-0.6c-0.8,0-1.4,0.4-1.8,1.1c-0.6,0.8-1.1,1.4-1.6,1.6
                  c-1.3,0.5-2.5,1.1-3.8,1.7c-0.6,0.3-1.2,0.5-1.9,0.7c-0.7,0.1-1.4,0.4-1.9,0.7c-0.6,0.3-1.2,0.5-1.9,0.8
                  c-0.6,0.2-1.3,0.5-1.9,0.8c-1.2,0.5-2.5,1.1-3.6,1.7c-0.6,0.3-1.3,0.6-2,0.9c-0.7,0.2-1.4,0.5-2.1,0.9
                  c-0.6,0.3-1.2,0.7-1.9,1.2s-1.2,0.8-1.8,1.1c-0.7,0.3-1.1,0.7-1.5,1.1c-0.4,0.5-0.9,0.9-1.3,1.2c0,0.5,0.5,0.8,1.5,0.9
                  c0.4,0,1.4,0,3.1,0l8.3-0.4c0.7,0,1.4-0.1,2.1-0.2c0.6-0.1,1.3-0.2,2-0.2c1.4-0.1,2.8-0.1,4.2-0.1c0.7,0,1.4,0.1,2.1,0.2
                  c0.7,0.1,1.4,0.2,2,0.1c1.4-0.1,2.8-0.1,4.2-0.2c0.7,0,1.4-0.1,2.1-0.2c0.7-0.1,1.4-0.2,2.1-0.2c0.7,0,1.4,0,2.1,0.1
                  c0.7,0.1,1.4,0.1,2,0l4.2-0.3c1.4-0.1,2.9-0.1,4.4-0.1l4.7-0.2c0.7,0,1.3-0.1,1.7-0.2c0.5-0.2,1-0.3,1.6-0.4
                  c0.7-0.1,1.2-0.2,1.4-0.3c0.3-0.1,0.5-0.2,0.6-0.2c0.9-0.1,1.2-0.2,0.8-0.5c-0.2-0.2-0.9-0.6-2-1.2L428.3,201.3z"
                />
              </g>
            </g>
          </g>
          <path
            fill="#FFFFFF"
            d="M432.1,169.7l-4.4-0.6c-5.8-1.4-12.5-4.5-20.1-9.2l-5.4-3.8c2.4,5,4.5,10.9,6.2,17.9c0.9,4,1.6,7.4,2,10.2
            l-1.3-0.6c-0.8-7.6-3-15.2-6.5-22.8l-4-7.3l-0.6-0.4c-4.2-1.6-9.6-1.3-16.1,1.1c-6.2,2.9-9.8,4.5-10.9,4.9
            c-5.6,2.3-12.6,3-20.8,2.2c5,3.1,10.4,7.4,16.4,13c3.4,3.2,6.3,6.2,8.6,8.8c-0.6,0.1-1.4-0.3-2.5-1.4
            c-5.4-5.5-11.6-10.8-18.8-15.8l-8.5-5.4l-6.6-1.2c-6.7-1.7-12.4-1.8-17.1-0.1c-2.3,0.8-4,1.8-5,2.9c4.7,0.6,9.6,3.1,14.7,7.5
            c2.5,2.2,4.6,4.3,6.2,6.4l15.2,16c4.4,5.4,11.2,10.7,20.2,15.8c4.5,2.5,8.6,4.5,12.2,5.9l42.2-3.9l14.5-42.6
            C438.8,168.9,435.6,169.8,432.1,169.7z"
          />
          <path
            fill="#231F20"
            d="M436.1,204.4l-0.2-0.3c-0.2-0.1-0.3-0.2-0.3-0.2c-0.3-0.6-1.2-1.2-2.6-1.7c-0.8-0.3-2.2-0.8-4.2-1.2
            c-0.4-0.1-1-0.5-1.8-1c-0.8-0.6-1.6-1-2.4-1.2c-0.9-0.2-2.4-0.7-4.4-1.4c-2.3-0.8-4-1.5-5.2-2.1c-1.1-0.3-2.8-1.2-5.2-2.5
            c-2.3-1.2-3.9-2-4.8-2.2c-3,2.2-6.4,4.1-10.3,5.7c-4.6,2.5-7.3,3.9-8.3,4.2c-0.8,0.2-1.6,0.6-2.5,1.1c-0.9,0.5-1.5,0.9-1.9,1
            c-4,1.3-6.3,2.6-6.8,3.8c-0.2,0.5-0.3,0.8-0.2,1l0.2,1.4c0.3,0,2,0,5.2-0.1c0.5,3.7,0.9,12.4,1.2,26.3c0,1.3,0,3.9-0.1,7.6
            c0,3.3,0.4,5.4,1.1,6.4c0.5,1.4,1.7,2.1,3.7,2.3c1.1,0.1,2.8,0.2,5,0.2c0.8,0.2,2,0.2,3.4,0c1.4-0.2,2.6-0.4,3.8-0.8l6-0.2
            c1.1,0,2.5,0,4,0c1.7,0,3.2,0,4.5,0l3.6-0.5c0.8,0.2,2.2,0.2,4.4,0c2.2-0.2,3.6-0.4,4.2-0.8c1.9-1,3.5-2,4.8-3.2
            c0.1-0.3,0.3-0.8,0.7-1.5c0.3-0.7,0.5-1.4,0.6-2c0.8-2.3,1-5.2,0.8-8.7c-0.4-1.5-0.5-2.6-0.4-3.5c0.4-2.5,0.3-6.6-0.3-12.5
            c-0.6-5.7-0.9-9.4-1-11.1c1.8-0.1,3.2-0.3,4.2-0.6c0.1,0,0.3,0,0.5,0.1c0.1,0,0.2,0,0.3,0l0.7-1
            C436.4,204.9,436.3,204.7,436.1,204.4z M378.8,207c0.7-0.5,1.7-1.1,2.8-1.8c2.1-1.2,3.7-2,4.8-2.5c1.5-0.5,3.4-1.3,5.8-2.4
            c2.7-1.3,4.3-2.2,4.7-2.9l8.2-3.3l8.5,2.8c0.6,0.2,2.4,1,5.4,2.4c2.7,1.2,4.5,1.9,5.4,2.1c0.6,0.1,2.3,1,5.1,2.5
            c0.3,0.2,0.6,0.3,0.9,0.5c-4.8,0.8-8.6,1.1-11.2,0.9c-2.6-0.1-4.2-0.1-4.8,0c-3.4,0.6-7.6,0.9-12.8,1c-5.6,0-9.7,0-12.1,0.1
            c-1.1,0-3.1,0.2-6,0.5C381.9,206.9,380.3,207,378.8,207z M428.9,240c-0.4,2.3-1.1,3.9-2,4.6c-2.1,1.8-6.5,2.7-13.2,2.8
            c-8.5,0.1-13.3,0.2-14.4,0.5c-2.9,0.6-5.1,0.9-6.8,0.8c-1.8-0.1-4-0.6-6.8-1.6c-0.5-2.4-0.8-4.8-0.8-7.3l0.2-2.9
            c-0.1-0.2-0.2-0.6-0.4-1.2c-0.2-0.7-0.3-1.1-0.2-1.2c0.1-1.2,0.2-2.1,0.2-2.9c0.1-1.3,0-2.4-0.2-3.2c-0.1-0.3-0.1-1,0-2
            c0-1.1,0-1.8-0.1-2.2c-0.3-1.3-0.6-3.9-1.1-7.6c-0.5-4.1-0.7-6.8-0.6-8.1c4,0,9.1,0,15.2,0.1c3.4,0,6.8-0.2,10.4-0.8
            c5.4-0.3,9.5-0.5,12.2-0.6c1.7-0.1,4.1-0.2,7.4-0.3c0.1,1.8,0.3,4.9,0.5,9.4c0.5,2.3,0.7,5.3,0.5,8.9c-0.2,3.8-0.1,6.8,0.3,9
            C429.3,235.9,429.3,237.9,428.9,240z"
          />
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_7_FILL">
                <path
                  fill="#231F20"
                  d="M412,215l-2.3,0.1l-7.3,9.8l-0.2-7.4l-0.1-0.4v-1.7l-1.9,0.1l0.8,23.3l1.9-0.1l-0.4-9.9l8.3,9.6l2.4,0
                  l-10-11.5L412,215z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_8_FILL">
                <path
                  fill="#231F20"
                  d="M449.8,203l3.1-5.9l-0.9-1.3l-1.8-0.7l-1.3,0.4l-1,3.6l-0.8-1.1c-0.5-0.5-0.7-0.7-0.8-0.4v0.5l0.9,3
                  l-2.6,11.2c-1.3,0.6-3.1,1.2-5.6,2c-3,0.9-5.4,1.5-7,2l0.7,4.2l4.6-1.9c3.7-1.6,6.9-3.1,9.7-4.5L449.8,203z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_9_FILL">
                <path
                  fill="#231F20"
                  d="M402,251.8l-3.6,0.1l-1.8,8.5c-1.1,7.1-1.3,14-0.8,20.8l2.5-0.1c-0.3-1.7-0.4-4.2-0.2-7.4
                  C398.4,267.1,399.7,259.8,402,251.8z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_10_FILL">
                <path
                  fill="#231F20"
                  d="M417,251.2l-3,0.1c1.5,3.9,3,8.2,4.6,12.9c0.4,1,0.6,1.5,0.6,1.5c1.1,6.1,1.6,10.9,1.6,14.6l1.8-0.1
                  c0.2-3.8,0.3-6.7,0.2-8.5c-0.1-2.4-0.4-4.6-0.9-6.4l-0.3-1.2c-1-3.5-2.1-6.7-3.2-9.6L417,251.2z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_11_FILL">
                <path
                  fill="#231F20"
                  d="M382.4,220.6l-2.2-1.8l-9.9,7.4l-1.6,2.1l0,0.8l9.9,7.4l0.6,0.8c0.2,0.6,0,1.1-0.8,1.5l-2,0.9l-0.1,1.4
                  l4.2-2c0.5-0.1,0.9-0.3,1.2-0.6c0.7-0.6,0.9-1.3,0.4-2.1l-1-2l-8.9-5.7l2.3-1.8c0.3-0.3,0.8-0.6,1.4-1c1.2-0.8,2.5-1.5,3.9-2.2
                  l2-1L382.4,220.6z"
                />
              </g>
            </g>
          </g>
          <path
            fill="#231F20"
            d="M372.7,181.8c1.1,1.1,1.9,1.6,2.5,1.4c-2.3-2.6-5.2-5.6-8.6-8.8c-5.9-5.6-11.4-9.9-16.4-13
            c-0.8-0.5-1.5-0.9-2.3-1.3l-3.2,0.1l0.7,0.4l8.5,5.4C361.1,171,367.3,176.3,372.7,181.8z"
          />
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_14_FILL">
                <path
                  fill="#231F20"
                  d="M399.5,201c-0.4,0.2-0.5,0.3-0.3,0.5c1.4,1.7,3.4,2.6,5.9,2.9c1.8,0.2,4,0.1,6.6-0.4
                  c0.3-0.1,0.5-0.2,0.6-0.5c0.1-0.2,0-0.3-0.5-0.2c-2.4,0.5-4.4,0.6-6,0.4c-2.3-0.3-4.1-1.2-5.5-2.7
                  C400.2,200.8,399.9,200.8,399.5,201z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_15_FILL">
                <path
                  fill="#231F20"
                  d="M397.6,187.8c0.1-0.5,0-0.7-0.2-0.8c-1.5-0.2-3,0.3-4.4,1.4c-1.3,1-2.1,2.2-2.3,3.6
                  c-0.1,0.3,0,0.6,0.2,0.8c0.1,0.2,0.2,0.1,0.3-0.4c0.1-1.1,0.9-2,2.3-2.9c1.4-0.8,2.6-1.2,3.9-1.1
                  C397.5,188.5,397.6,188.3,397.6,187.8z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_16_FILL">
                <path
                  fill="#231F20"
                  d="M412.1,187.5c-0.1,0.1-0.2,0.3-0.1,0.7c0.1,0.4,0.2,0.6,0.3,0.6c1-0.4,2.1-0.4,3.3,0.1
                  c1.3,0.4,2,1.1,2.2,2.1c0.1,0.4,0.2,0.5,0.3,0.3c0.1-0.2,0.1-0.4,0-0.7c-0.3-1.2-1.1-2.1-2.2-2.7
                  C414.6,187.1,413.4,187,412.1,187.5z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_17_FILL">
                <path
                  fill="#231F20"
                  d="M399.8,191c-0.9-0.9-2-1.2-3.5-0.9l-2,0.6c-1.3,0.9-2,2.3-2,4.1c0,0.9,0.1,1.7,0.4,2.4l8.8-3.5
                  L399.8,191z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_18_FILL">
                <path
                  fill="#231F20"
                  d="M399.6,191.8c-0.8-0.9-1.8-1.3-2.9-1.2c-1.1,0.1-2.1,0.5-2.8,1.4c-0.7,0.9-1.1,2-1,3.3
                  c0.1,1.3,0.5,2.3,1.3,3.2c0.8,0.9,1.8,1.3,2.8,1.2c1.1,0,2-0.5,2.8-1.4c0.8-0.9,1.1-2,1.1-3.3
                  C400.9,193.8,400.5,192.7,399.6,191.8z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_19_FILL">
                <path
                  fill="#FFFFFF"
                  d="M400.7,195.2c0-1.2-0.4-2.1-1.2-2.9s-1.6-1.2-2.6-1.1c-1,0.1-1.8,0.5-2.5,1.3c-0.7,0.9-1,1.9-1,3
                  c0.1,1.2,0.5,2.2,1.2,2.9c0.7,0.8,1.6,1.2,2.5,1.2c1,0,1.8-0.5,2.5-1.3C400.4,197.4,400.7,196.4,400.7,195.2z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_20_FILL">
                <path
                  fill="#231F20"
                  d="M399,196.1c0-0.6-0.3-1.2-0.7-1.6s-0.9-0.6-1.4-0.6c-0.5,0-1,0.2-1.4,0.7c-0.4,0.5-0.5,1-0.5,1.6
                  s0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.6,1.4,0.6c0.6,0,1-0.3,1.4-0.8C398.8,197.3,399,196.7,399,196.1z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_21_FILL">
                <path
                  fill="#FFFFFF"
                  d="M398.8,195.1c0-0.4-0.2-0.6-0.6-0.6c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.4
                  c0,0.4,0.2,0.6,0.7,0.6c0.2,0,0.3-0.1,0.4-0.2C398.8,195.4,398.8,195.3,398.8,195.1z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_22_FILL">
                <path
                  fill="#231F20"
                  d="M413.3,189.8c-1.5-0.1-2.6,0.3-3.4,1.2l-1.5,2.8l8.9,2.8c0.2-0.7,0.3-1.5,0.2-2.4
                  c-0.1-1.8-0.8-3.1-2.2-3.9C414.8,190.1,414.1,189.9,413.3,189.8z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_23_FILL">
                <path
                  fill="#231F20"
                  d="M416,192.1c-0.5-0.9-1.3-1.4-2.2-1.6c-1-0.1-1.9,0.1-2.8,0.8c-0.8,0.7-1.4,1.6-1.6,2.8
                  c-0.2,1.1-0.1,2.2,0.5,3.1c0.5,0.9,1.3,1.4,2.2,1.5c1,0.2,1.9-0.1,2.8-0.8c0.8-0.7,1.4-1.6,1.6-2.8S416.5,193,416,192.1z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_24_FILL">
                <path
                  fill="#FFFFFF"
                  d="M413.8,191c-0.8-0.1-1.6,0.1-2.4,0.8c-0.8,0.6-1.3,1.5-1.5,2.5c-0.2,1-0.1,2,0.4,2.8
                  c0.5,0.8,1.1,1.3,2,1.4s1.7-0.1,2.5-0.8c0.8-0.6,1.3-1.5,1.5-2.5c0.2-1,0.1-2-0.4-2.8C415.3,191.6,414.6,191.2,413.8,191z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_25_FILL">
                <path
                  fill="#231F20"
                  d="M414,195.9c0.1-0.6,0-1.1-0.2-1.5c-0.3-0.5-0.6-0.7-1.1-0.8c-0.5-0.1-1,0.1-1.4,0.4
                  c-0.4,0.4-0.7,0.8-0.8,1.4c-0.1,0.6,0,1.1,0.2,1.6c0.3,0.4,0.6,0.7,1.1,0.8c0.5,0.1,1-0.1,1.4-0.4
                  C413.6,196.9,413.9,196.5,414,195.9z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_CAPTAIN_KEYBOARD_0_Layer2_26_FILL">
                <path
                  fill="#FFFFFF"
                  d="M414.1,195c0.1-0.3-0.1-0.5-0.5-0.6s-0.6,0.1-0.7,0.4c-0.1,0.3,0.1,0.5,0.5,0.6
                  C413.9,195.5,414.1,195.3,414.1,195z"
                />
              </g>
            </g>
          </g>
        </g>
        <rect x="235" y="298.8" fill="none" width="322.3" height="49.5" />
        <text
          transform="matrix(1 0 0 1 236.95 331.9909)"
          fill="#231F20"
          font-family="'ArialMT'"
          font-size="30px"
        >Certificate of Completion</text>
        <rect x="357.6" y="339.9" fill="none" width="77.1" height="25.2" />
        <text
          transform="matrix(1 0 0 1 359.6 356.4409)"
          fill="#231F20"
          font-family="'ArialMT'"
          font-size="14px"
        >awarded to:</text>
        <g>
          <text
            font-size="30px"
            font-family="'hwtprint'"
            fill="#231F20"
            transform="matrix(1 0 0 1 395 405)"
            text-anchor="middle"
          >{{ studentName }}</text>
          <path
            id="Cert_Certificate_0_Layer3_8_1_STROKES"
            fill="none"
            stroke="#231F20"
            d="M96.6,411.3h607.6"
          />
        </g>
        <rect x="293.7" y="420.1" fill="none" width="204.9" height="25.2" />
        <text
          transform="matrix(1 0 0 1 295.7 433.6909)"
          fill="#231F20"
          font-family="'ArialMT'"
          font-size="14px"
        >for being a Speedy Keyboard Kid!</text>
        <rect x="92.1" y="363.6" fill="none" width="609" height="64.7" />
        <rect x="96.7" y="487.1" fill="none" width="193.4" height="28.3" />
        <rect x="510.8" y="487.1" fill="none" width="193.4" height="28.3" />
        <g>
          <path fill="#231F20" d="M458,505.5v-2.7h0.8v-0.5h-2v0.5h0.7v2.7H458z" />
          <path
            fill="#231F20"
            d="M461.8,503.5l0.3,2h0.6l-0.5-3.2h-0.6l-0.8,2.1l-0.8-2.1h-0.6l-0.6,3.2h0.6l0.3-2l0.8,2h0.2L461.8,503.5z"
          />
          <path
            fill="#231F20"
            d="M337.1,476.2h-2.1c-3.7,4.6-5.9,7.3-6.6,8.1v-8.1h-1.7v20.2h1.6v-8.6l6.9,8.6h2l-8.3-10.3L337.1,476.2z"
          />
          <path
            fill="#231F20"
            d="M347.9,476.2h-9.2v20.1l9.2,0.1v-1.6l-7.6-0.1v-7.6h7.6v-1.6h-7.6v-7.6h7.6V476.2z"
          />
          <path
            fill="#231F20"
            d="M361,476.2h-2l-3.5,8.4l-4.7-8.4h-1.8l5.5,10.4v9.8h1.8v-9.8L361,476.2z"
          />
          <path
            fill="#231F20"
            d="M364,476.1l-1.5,0.1v20.1c1.6,0,2.8-0.2,3.7-0.6c0.9-0.4,1.7-0.9,2.2-1.7c0.6-0.7,0.9-1.6,0.9-2.8
            c0-1.8-0.8-3.3-2.5-4.7c0.9-0.5,1.6-1.2,2.1-2.3c0.4-0.9,0.6-1.8,0.6-2.8v-0.1c0.1-0.5-0.1-1.3-0.5-2.3c-0.6-1.3-1.5-2.2-2.8-2.7
            C365.4,476.3,364.7,476.1,364,476.1 M366,478.2L366,478.2c0.5,0.3,1.1,0.8,1.5,1.5c0.4,0.7,0.5,1.3,0.5,1.9c0,1.3-0.4,2.3-1.1,3
            c-0.6,0.6-1.3,0.9-2.1,0.9h-0.5l-0.1-7.6h0.6C365.2,477.9,365.6,478,366,478.2 M364.5,487.4c1,0,1.8,0.6,2.5,1.6
            c0.6,0.8,0.8,1.6,0.8,2.4c0,1-0.7,2-2,2.8c-0.7,0.3-1.2,0.4-1.6,0.4v-7.1H364.5z"
          />
          <path
            fill="#231F20"
            d="M378.6,476.2c-2.3,0-4.2,1.2-5.8,3.7c-1.4,2.2-2,4.5-2,6.9c0,2.5,0.6,4.6,1.7,6.4c1.4,2.2,3.4,3.3,6.1,3.3
            s4.8-1.1,6.2-3.4c1.1-1.8,1.7-3.9,1.7-6.3c0-2.3-0.7-4.5-2.1-6.7C382.8,477.5,380.9,476.2,378.6,476.2 M378.6,477.8
            c1.9,0,3.5,1.2,4.7,3.5c1,1.9,1.6,3.7,1.6,5.4c0,2-0.4,3.7-1.3,5.2c-1.1,1.9-2.8,2.8-4.9,2.8s-3.8-1-4.9-3
            c-0.8-1.5-1.3-3.2-1.3-5.1c0-1.8,0.5-3.7,1.6-5.5C375.2,478.9,376.7,477.8,378.6,477.8z"
          />
          <path
            fill="#231F20"
            d="M394.1,476.2h-1.2c-1.1,3.4-3.6,10.2-7.5,20.2h1.9c0.6-1.8,1.4-4.3,2.6-7.3c0.3-1,0.6-1.6,0.7-1.9h6
            l0.6,1.4c1.8,4.5,2.8,7.1,3.1,7.8h1.8L394.1,476.2 M395.9,485.4h-4.7l2.3-5.9L395.9,485.4z"
          />
          <path
            fill="#231F20"
            d="M405,476.2c-1.2,0-1.8,0-1.8,0v20.2h1.7v-7.5l5.3,7.5h2c-2.9-4.3-5-7.3-6.4-9c0.6-0.1,1.3-0.4,2-0.6
            c1.9-1.1,2.9-2.7,2.9-4.9c0-0.8-0.3-1.7-0.8-2.6c-0.5-0.8-1.2-1.5-2-2.1C406.9,476.5,405.9,476.2,405,476.2 M405.1,477.8
            c1,0,1.9,0.4,2.8,1.3c0.8,0.9,1.2,1.8,1.2,2.8c0,1.5-0.5,2.6-1.6,3.3c-0.8,0.5-1.5,0.8-2.1,0.8h-0.5v-8.1H405.1z"
          />
          <path
            fill="#231F20"
            d="M422.1,480.9c-1.5-2.5-3.9-4.1-7.1-4.7h-1.4v20.1l0.8,0.1c0.8,0,1.7-0.1,2.6-0.4c2.3-0.9,4.1-2.4,5.2-4.5
            c0.9-1.6,1.3-3.4,1.3-5.4C423.7,484.4,423.2,482.6,422.1,480.9 M415.2,478c1.7,0.2,3.1,1,4.2,2.3c0.8,0.8,1.5,1.9,2,3.2
            c0.4,1,0.6,1.9,0.6,2.7c0,2.1-0.7,4-2,5.7c-1.3,1.6-2.9,2.6-4.8,2.8V478z"
          />
          <path
            fill="#231F20"
            d="M428.8,477.8h2.2v-1.6h-6.1v1.6h2.2l-0.1,17h-2.1v1.6h6.1v-1.6h-2.3L428.8,477.8z"
          />
          <path
            fill="#231F20"
            d="M446.4,476.2h-1.8l0.1,16.3l-9.9-16.3h-1.6v20.2h1.6v-16.7l10.1,16.7h1.5V476.2z"
          />
          <path
            fill="#231F20"
            d="M451.9,481.4c1.4-2.4,3.3-3.5,5.8-3.5l1.5,0.1v-1.6c-0.5-0.1-1-0.2-1.6-0.2h-0.9c-1.8,0.1-3.6,1.2-5.2,3.1
            c-1.8,2.1-2.7,4.6-2.8,7.3c0,3.1,0.8,5.6,2.4,7.4c0.9,1,1.8,1.7,2.7,2c1,0.2,1.9,0.4,2.5,0.4c1.4,0,2.4-0.5,3-1.4
            c0.7-1,1.1-2.7,1.1-5.1v-2.7h2.2v-1.6H456v1.6h2.5v2.7c0,2.8-0.4,4.3-1.3,4.6c-0.3,0.1-0.7,0.2-1.1,0.2c-0.5,0-0.8,0-1.1-0.1
            c-1.1-0.3-2-0.9-2.8-1.8c-1.2-1.4-1.8-3.4-1.8-6C450.2,485,450.7,483.2,451.9,481.4z"
          />
          <path
            fill="#231F20"
            d="M440,507.9h-3.2v0.9c-0.7-0.8-1.6-1.2-2.8-1.2c-1.3,0-2.4,0.5-3.3,1.4c-0.8,0.9-1.3,2.1-1.3,3.4
            c0,1.3,0.4,2.4,1.3,3.4c0.9,0.9,2,1.4,3.3,1.4c1.2,0,2.1-0.4,2.7-1.3h0.1v1h3.2V507.9 M433.4,511c0.4-0.4,0.9-0.6,1.5-0.6
            c0.7,0,1.2,0.2,1.6,0.6c0.3,0.4,0.5,0.8,0.5,1.4c0,1.4-0.7,2-2,2c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5
            C432.8,511.8,433,511.3,433.4,511z"
          />
          <path
            fill="#231F20"
            d="M348.7,505.7c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.1-0.8-0.4-1.1
            c-0.3-0.3-0.6-0.4-1.1-0.4c-0.4,0-0.7,0.1-1.1,0.4c-0.3,0.3-0.4,0.6-0.4,1.1C348.3,505.1,348.4,505.4,348.7,505.7z"
          />
          <path fill="#231F20" d="M419.6,503v-3h-9.1v3h2.8v13.9h3.5V503H419.6z" />
          <path
            fill="#231F20"
            d="M382.4,508.8c-1-0.8-2.2-1.3-3.7-1.3s-2.8,0.4-3.8,1.3c-1.1,0.9-1.6,2.1-1.6,3.5c0,1.5,0.5,2.7,1.6,3.6
            c1,0.8,2.3,1.2,3.8,1.2s2.8-0.4,3.7-1.3c1.1-0.9,1.6-2.1,1.6-3.5C384,510.9,383.5,509.7,382.4,508.8 M378.7,510.3
            c0.6,0,1.1,0.2,1.5,0.6c0.4,0.4,0.6,0.8,0.6,1.4c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-0.9,0.6-1.5,0.6c-1.4,0-2-0.7-2-2
            c0-0.6,0.2-1,0.5-1.4C377.5,510.5,378,510.3,378.7,510.3z"
          />
          <path
            fill="#231F20"
            d="M385.5,507.9v5.4c0,2.6,1.6,3.9,4.8,3.9c3.2,0,4.8-1.3,4.8-3.9v-5.4h-3.3v4.8c0,1.3-0.5,2-1.6,2
            c-1.1,0-1.6-0.7-1.6-2v-4.8H385.5z"
          />
          <path
            fill="#231F20"
            d="M442.1,507.9v9h3.2v-3.7c0-1.8,0.8-2.7,2.3-2.7c0.5,0,0.9,0.1,1.3,0.3v-3h-0.6c-1.4,0-2.3,0.5-2.9,1.6
            h-0.1v-1.5H442.1z"
          />
          <path
            fill="#231F20"
            d="M427.4,508.9c-0.9-0.9-2.1-1.3-3.7-1.3c-1.5,0-2.6,0.4-3.5,1.3c-0.9,0.9-1.4,2.1-1.4,3.5
            c0,1.5,0.5,2.7,1.5,3.6c0.9,0.8,2.2,1.2,3.7,1.2c1.1,0,2.1-0.3,2.9-0.8c0.9-0.5,1.5-1.3,1.7-2.3h-3c-0.3,0.6-0.8,0.8-1.6,0.8
            c-1.3,0-2-0.7-2-2h6.7v-0.4C428.7,511,428.3,509.8,427.4,508.9 M425.7,511.1h-3.7c0.1-1,0.8-1.5,1.8-1.5S425.6,510.1,425.7,511.1z
            "
          />
          <path
            fill="#231F20"
            d="M453.3,510.4c0-0.4,0.3-0.6,1-0.6c0.7,0,1.3,0.1,1.8,0.4l1.1-2c-0.8-0.4-1.8-0.6-3-0.6
            c-1.1,0-2,0.3-2.7,0.8c-0.8,0.6-1.3,1.4-1.3,2.4c0,1.2,0.7,2,2,2.4c0.3,0.1,0.8,0.2,1.3,0.4c0.4,0.1,0.6,0.4,0.6,0.6
            c0,0.5-0.3,0.7-1,0.7c-0.7,0-1.5-0.3-2.5-0.9l-1.1,2.2c1.1,0.7,2.3,1.1,3.6,1.1c1.2,0,2.2-0.3,3-0.8c0.9-0.6,1.3-1.5,1.3-2.5
            c0-1.5-0.9-2.4-2.6-2.7C453.8,511,453.3,510.8,453.3,510.4z"
          />
          <path
            fill="#231F20"
            d="M398.5,508.2v8.7h3.1v-8.7h1.8v-2.6h-1.8v-5.5h-3.1v5.5h-2v2.5L398.5,508.2z"
          />
          <path
            fill="#231F20"
            d="M347.1,500.1h-3.6l-2.5,10.8h-0.1l-2.6-10.8h-2.8l-2.8,10.8l-2.4-10.8h-3.6l4,16.8h3.5l2.7-9.8l2.4,9.8
            h3.5L347.1,500.1z"
          />
          <path fill="#231F20" d="M348.2,508.1v8.8h3.1v-8.8H348.2z" />
          <path
            fill="#231F20"
            d="M365.5,500h-3.2v16.9h3.2v-4.7c0-1.4,0.6-2.1,1.7-2.1c0.9,0,1.4,0.7,1.4,2.1v4.7h3.3v-5.5
            c0-2.5-1.1-3.8-3.4-3.8c-1.2,0-2.2,0.5-2.9,1.5h-0.1V500z"
          />
          <path
            fill="#231F20"
            d="M358.5,505.6v-5.5h-3.1v5.5h-2v2.5h2v8.8h3.1v-8.8h1.8v-2.5H358.5z"
          />
        </g>
        <g id="Stars">
          <path
            fill="#66C0BE"
            d="M164.5,132.6l-0.2-11.7l10.1-4.4l-9.2-4.1l3-15.2l-9.4,12.9l-11.9-3.3l6.4,9.9l-7.2,11.1l12.1-4.5
            L164.5,132.6z"
          />
          <path
            fill="#66C0BE"
            d="M630.8,132.6l6.3-9.1l12.1,4.5l-7.2-11.1l6.5-9.9l-12,3.3l-9.3-12.9l2.9,15.2l-9.2,4.1l10.1,4.4
            L630.8,132.6z"
          />
          <path
            fill="#66C0BE"
            d="M133.2,133.7L121.8,118l9.1-12.7l-14.8,3l-9.3-19.4l-0.2,22.1L92,118l14.4,6.2l0.3,20.5l8.9-16.8
            L133.2,133.7z"
          />
          <path
            fill="#66C0BE"
            d="M704.3,118l-14.5-7.1l-0.2-22.1l-9.4,19.4l-14.8-3l9.1,12.7l-11.4,15.7l17.6-5.8l8.9,16.8l0.2-20.5
            L704.3,118z"
          />
          <path
            fill="#66C0BE"
            d="M112.1,160.4l-8.3,2.1l-6-11.8l0.6,13.6l-9.8,4l9.6,3.3l0.9,11.1l5.8-9.3l9,2.8l-6.3-7.7L112.1,160.4z"
          />
          <path
            fill="#66C0BE"
            d="M698,164.4l0.5-13.6l-5.9,11.8l-8.4-2.1l4.5,8.2l-6.3,7.7l9.1-2.8l5.8,9.3l1-11.1l9.5-3.3L698,164.4z"
          />
        </g>
        <path
          id="frameColor"
          fill="#66C0BE"
          d="M765.1,29.1l-6.1-0.5l-341.3-0.5H37.3l-5.8,4.5l-1.1,16.3l-6.6,211.3l0.9,311.5l2.9,3.6
          h22.3l326.1,7.8l355-0.5l26.6-0.3l5.8-5.6l2.2-9.1l2.9-155l1.2-206.3L771.2,38L765.1,29.1 M723.7,66.4L728,73l0.4,236.8l-3.3,219.7
          l-2.9,7.9l-13,2.6l-306,0.5l-332.6-1.9l1.4-8.5l-0.8-221.8L68.5,97.9l2.2-25.3h298L723.7,66.4z"
        />
        <g id="border" transform="matrix( 1, 0, 0, 1, 138,102.3) ">
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_7_FILL">
                <path
                  fill="#DCDDDE"
                  d="M633.7-68.3c-0.4-0.6-0.9-1.1-1.8-1.3c-1-0.3-1.7-0.5-2.2-0.7c0,1.3,0.5,2,1.3,2.1
                  C631.6-68.1,632.5-68.2,633.7-68.3z"
                />
              </g>
            </g>
          </g>
          <path
            fill="#242122"
            d="M636-30.6c-0.1-8.1-0.1-13.6,0-16.5c0.1-8-0.7-15.1-2.3-21.2c-0.3-0.3-1-0.6-2.1-0.9
            c-0.9-0.2-1.5-0.6-1.8-1.1c-1.8-1.1-4-1.8-6.7-2.2c-3.1-0.3-5.5-0.6-7.1-0.8c-0.7-0.4-1.6-0.6-2.7-0.7c-1.2,0.1-2.2,0.1-2.8,0.1
            l-24.8,0.2c-9.9,0.1-18.2,0.1-24.8,0c-21.9-0.2-54.9-0.3-98.8-0.2c-43.9,0-76.8-0.1-98.8-0.3c-30.2-0.3-68.1-0.4-113.8-0.4
            c-72.3,0-110.2,0-113.8,0c-24.9,0-43.5,0-56,0c-21.9,0-40.5-0.2-56-0.4c-3.9-0.1-9.9-0.3-17.8-0.8c-7.9-0.4-13.8-0.7-17.8-0.8
            c-12.2-0.2-19.5-0.4-22-0.5c-6-0.2-13.3-0.4-22-0.4c-9.8,0.1-17.1,0.1-22,0c-1.3,0-2.4,0.1-3.2,0.4c-1.1,0.4-1.9,1.1-2.5,2.2
            c-0.3,0.6-0.8,0.9-1.4,1c-0.3,0.1-0.9,0.1-1.9,0.1l-8,0c-1.2,0-2.1,0.1-2.8,0.2c-1,0.2-1.8,0.6-2.5,1.2c-0.3,3-0.3,4.7,0.2,5.3
            c0.4,0.5,2.2,1.1,5.2,1.8c2.2,0.5,5.5,0.6,10,0.3c4.4-0.2,7.8-0.1,9.9,0.4c1.3-0.3,3-0.5,5.1-0.7c3.1-0.2,4.9-0.3,5.2-0.3
            c2.8-0.2,6.5-0.1,11.1,0.4c5.5,0.6,9.2,1,11,1c1-0.1,1.9-0.1,2.8-0.1c1,0,2.6-0.1,4.6-0.5s3.6-0.6,4.6-0.6
            c6,0.1,15.9-0.4,29.7-1.2c12.7-0.8,22.6-1.1,29.7-0.8c12.9,0.4,25.1,0.5,36.5,0.2c6.9-0.2,17.5-0.2,31.6,0
            c13.9,0.2,24.5,0.2,31.5,0c2.2-0.1,6.1,0.1,11.9,0.6c5,0.4,9,0.5,11.9,0.1c3.4-0.4,7.4-0.6,12.2-0.7c2.7,0,6.8,0,12.2,0
            c11.1-0.1,27.8-0.1,50.1,0c41.3-0.2,83.5,0,126.8,0.5c3.1,0.1,7.2,0,12.4-0.2c6.2-0.2,10.4-0.4,12.4-0.4c9.1-0.1,21.1,0,36,0.3
            c18.7,0.3,30.7,0.5,36,0.5c13.6,0.1,30.2,0.2,49.6,0.2c11,0,27.6,0,49.6-0.1c4.2,0,7.1,0.1,8.8,0.4c0.3-0.1,0.7-0.2,1.1-0.3
            c0,0,0.1,0.1,0.1,0.1c0.6,0.3,1.5,0.5,2.7,0.5c1.1,0,2.7,0.1,4.8,0.2c1.8,0,3.4,0,4.8-0.2c7.2-1,15.8-1.5,25.6-1.5
            c5.7,0,14.2,0,25.7,0.2c0.6,0,1.2,0.2,1.8,0.5c0.4,0.2,0.9,0.5,1.5,1c0.9,0.6,1.4,1.6,1.5,3.2c0.5,7.3,0.4,14.4-0.1,21.2l-0.2,2.5
            c-0.3,2.3-0.1,5.5,0.6,9.5c0.7,4.4,1,7.6,1,9.5c-0.2,9.8-0.2,24.4,0.1,44c0,17.6-0.6,32.2-1.9,43.9c-0.1,6.2-0.1,24.7-0.2,55.7
            c0,22.7-0.3,41.2-0.7,55.6c-0.4,14.3-0.6,33.4-0.6,57.3c0,28.6,0,47.7-0.2,57.3c-0.9,58.6-1.3,102.6-1.2,131.9c0,3.9,0,9.6,0,17.3
            c-0.1,6.6-0.4,12.4-0.9,17.3c-0.1,1-0.3,2.4-0.6,4.3c-0.2,1.7-0.1,3.1,0.2,4.3c0.2,0.4,0.3,0.7,0.5,1c-1,0.3-1.7,0.9-2.1,1.8
            c-0.2,0.5-0.3,1.4-0.4,2.5c-0.1-0.1-0.3-0.2-0.4-0.3c-1.7-0.6-3.5-0.6-5.4,0c-3.1,1.3-6.8,2-11,1.9c-1,0-5.6-0.3-13.8-0.8
            c-5.6-0.4-10.2-0.3-13.8,0c-3.6,0.4-7.9,0.6-13.1,0.7c-5.8,0-10.2,0-13.1,0c-4.1,0.1-10.9,0-20.5-0.1c-8.8-0.1-15.7-0.1-20.6,0.1
            c-4.4,0.1-10.4,0-18.2-0.4c-8.6-0.4-14.7-0.6-18.2-0.6c-13,0.2-22.7,0.2-29.2,0.2c-11.3,0-21.1-0.2-29.2-0.6
            c-2.3-0.2-3.9,0.7-4.9,2.5c-0.1-0.4-0.2-0.9-0.5-1.5c-0.9-0.8-2-1.2-3.4-1.3c-0.3,0-1.5,0-3.7,0c-20.2-0.1-35.3-0.2-45.3-0.2
            c-18-0.1-33.2-0.3-45.4-0.5c-13.2-0.3-28.7-0.4-46.5-0.4c-20.7,0.1-36.2,0.2-46.5,0.2c-11.5,0.1-27.5,0.1-48,0
            c-22.5,0-38.5,0-48,0c-2.1-0.1-3.6-0.1-4.6,0c-1.8,0.1-3.2,0.6-4.3,1.6c-0.1,0.2-0.1,0.4-0.1,0.6c0,0,0,0,0,0
            c-15.1-0.3-26.4-0.5-33.9-0.8c-3.1,0-5.4-0.1-6.9-0.2c-2.7-0.1-5-0.4-6.9-0.8c-4.1,0.2-8.6,0.1-13.5-0.4c-4.6-0.4-10-0.6-16.2-0.5
            c-7.1,0.3-12.4,0.6-16.1,0.7c0-0.2,0-0.3,0-0.5c-0.5-1.1-1.4-1.8-2.6-2.1c-1.5-0.1-2.7-0.3-3.5-0.4c-5.4-0.8-12.1-1.2-20-1.1
            c-8.9,0.2-15.6,0.3-20,0.3c-6.2,0-15.1-0.2-26.7-0.6c-12.2-0.4-21.1-0.7-26.6-0.7c-4.6-0.1-8-0.1-10.2-0.1c-4.1,0-7.5,0-10.3,0.2
            c-3.2,0.2-5.3-0.2-6.4-1.2c-1.1-1-1.7-3.1-1.8-6.3v-4.1c0-12.8,0.3-35.8,0.8-68.9c0.3-18.2,0.3-50.3,0.2-96.3
            c-0.1-40.8,0.1-72.9,0.6-96.4c0.2-10.7,0.4-23.7,0.4-39c-0.1-17.4-0.2-30.4-0.2-39c0-4.5,0.2-7.8,0.5-10c0.1-1,0.1-2.1,0.1-3.1
            c0-0.5,0.1-1.1,0.2-1.9c0.1-1.5,0.1-4.8,0.1-9.8c0-4.1,0.2-7.3,0.5-9.8c-0.3-7-0.5-12.2-0.7-15.8c-0.2-6.2,0-11.4,0.5-15.8
            c0.4-2.8,0.4-6.5,0.2-11c-0.4-6.3-0.5-10-0.5-11.1c0-1.2,0-2.1-0.1-2.5c-0.1-0.7-0.4-1.3-0.9-1.8c0-4,0-7.3,0-9.7
            c0-0.8-0.1-1.4-0.3-2c0-11.8,0-19.1,0-22c0-1,0.2-2.5,0.5-4.5c0.3-1.9,0.5-3.5,0.5-4.5c-0.1-8.4-0.1-15.2,0.1-20.3
            c0.2-7.4,0.8-14.2,1.5-20.2c0.2-1.6,0.1-3.8-0.3-6.4c-0.3-2.2-1.5-2.6-3.5-1.2c-0.7,1.9-1.2,4.2-1.5,6.7c-0.2,1.6-0.3,3.9-0.5,6.8
            c-0.1,3.1-0.2,5.2-0.3,6.3c-0.8,6.1-1.3,11.5-1.4,16.3c-0.1,6.5-0.2,20.5-0.1,42c0,17.3-0.2,31.3-0.7,41.9
            c-0.3,5.9-0.4,14.4-0.5,25.3c0,11.6-0.1,20-0.3,25.2c-0.2,7.2-0.4,16.1-0.4,26.7c0,5.9,0,14.8,0,26.6c-0.3,0.4-0.4,0.9-0.5,1.5
            c0,0.2,0,0.7,0,1.6c0,3.5-0.1,8.8-0.1,16c-0.1,6.9-0.2,22.3-0.4,46.3c-0.1,19.1-0.3,34.5-0.5,46.3c-0.3,13.3-0.4,34.1-0.3,62.3
            c0.1,27.2-0.1,48-0.5,62.2c-0.5,21.2-0.6,42.8-0.2,64.8c0.1,3.7,0.7,7.3,1.8,10.8c1.4,4.4,4.5,6.3,9.2,5.8c0.5,0,1.2-0.1,2-0.2
            c0.8-0.1,1.5,0,2.1,0.1c4.3,0.9,9.5,1.5,15.5,1.8c3.5,0.1,8.7,0.2,15.6,0.2c8.9,0.2,22.4,0.5,40.2,1c15.6,0.3,29,0.5,40.2,0.3
            c2.1-0.1,3.5,0,4.2,0.1c3.4,0.6,7.5,0.8,12.4,0.8c2.7,0,6.9,0,12.4-0.1c1.9,0,4.7,0,8.4-0.1c3.3,0,6.1,0.1,8.4,0.4
            c8.4,0.8,16,1.3,22.8,1.5c6.5,0.2,15.2,0.4,26,0.4c13.2,0.1,21.9,0.2,26,0.3c11.9,0.2,26.8,0.3,44.4,0.3c9.9,0,24.7,0,44.5-0.1
            l85.1,0.2c0.5,0.4,1.1,0.7,1.9,0.7c0.5,0,1.2,0,2.1,0c4.8,0,12,0,21.5,0c8.5,0,15.7,0.1,21.5,0.2c1.6,0,9.3,0,23.1,0
            c9.3,0,17,0.2,23.1,0.7c3.2,0.3,7.4,0.4,12.6,0.5c6.8,0.1,11,0.1,12.6,0.2c8.4,0.3,21.1,0.5,38.1,0.5c16.8,0,29.5,0.1,38.1,0.5
            c6.1,0.2,13.4,0.3,22,0.3c4.9,0,12.2,0,22-0.1c0.6,0,1.6,0,2.8,0c1.1,0,2-0.2,2.7-0.7l2.4-0.2l31.3,0.3c0.5,0,2,0.1,4.5,0.4
            c1.8,0.2,3.2,0.2,4.3,0c2.9-0.4,6.4-0.6,10.5-0.7c2.3,0,5.8,0,10.5,0c4,0,7-1.3,9-4c1.3-1.7,2.8-3.9,4.5-6.5
            c0.9-1.5,2.3-3.8,4.2-6.8c0.1-0.1,0.1-0.2,0.1-0.4c-0.1-0.3-0.1-0.5-0.1-0.5c2-2.5,2.2-5.4,0.8-8.8c-0.3-0.6-0.4-1.5-0.5-2.5
            c0-1.1,0-2-0.1-2.5c-0.1-1.9-0.1-4.4,0.2-7.5c0.3-3.9,0.5-6.4,0.5-7.5c0.1-9.8,0.2-34,0.2-72.5c0-29.8,0.2-54,0.8-72.5
            c0.3-10.2,0.4-26,0.4-47.2c-0.1-20.7,0.1-36.5,0.4-47.2c0.3-10.5,0.5-25.6,0.5-45.4c0-20.6,0.1-35.8,0.4-45.4
            c0.3-12.2,0.5-32.5,0.4-60.9c-0.1-26.1,0.2-46.4,0.8-60.9C636-18.3,636.1-23.7,636-30.6z"
          />
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_15_FILL">
                <path
                  fill="#242122"
                  d="M374.2,480.2c-0.2-0.7-0.6-1-1.4-0.9c-0.2,0-0.4,0.1-0.5,0.3c-0.1,0.2-0.1,0.4,0,0.6
                  c0.2,0.3,0.5,0.6,1,0.7C374,481,374.2,480.8,374.2,480.2z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_19_FILL">
                <path
                  fill="#4E4E50"
                  d="M616.6,476.6c1.6,0.2,3,0,4.1-0.8c-1.2-0.1-1.9-0.1-2.1-0.1C617.8,475.9,617.1,476.1,616.6,476.6z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_35_FILL">
                <path
                  fill="#D8DADB"
                  d="M-99.9,12.3c-0.1-0.7-0.3-1-0.7-1c-0.5,0-0.7,0.4-0.7,1c0,0.6,0.2,0.9,0.7,0.9
                  C-100.2,13.2-100,12.9-99.9,12.3z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_42_FILL">
                <path
                  fill="#302E2F"
                  d="M579.2,462.1c0.6-1.1,0.9-2.4,0.9-3.9c-0.2-1.8-0.3-3.1-0.3-3.9c-0.1-2.1-1.2-4.2-3.3-6.2
                  c-2.1-2-4.5-3.3-7.2-3.9c-2.9-0.6-4.9-0.7-6.2-0.1c-1.2,0.5-2.7,2.1-4.2,4.7c-1.6,1-2.8,1.7-3.6,2.2c-1.3,0.9-2.3,1.9-3.1,2.9
                  c-0.8,2-1.2,4.1-1.2,6.2c0,2.5,0.6,4.7,2,6.3c1.3,1.6,3.2,2.7,5.8,3.3c3.1,0.7,6.3,0.4,9.4-0.9
                  C573,466.8,576.6,464.6,579.2,462.1z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_46_FILL">
                <path
                  fill="#322F30"
                  d="M497.1,454c-1.6,1.6-2.5,2.5-2.6,2.6c-2.7,3.3-3,6.3-0.8,9.1c1,1.2,2.8,2.2,5.4,3
                  c2.6,0.8,4.5,0.9,5.8,0.3c2.4-1,4-2.9,4.8-5.8c0.7-2.8,0.3-5.3-1.3-7.6c-1.5-1.5-3.2-2.4-5.3-2.5
                  C501.5,453.2,499.6,453.5,497.1,454z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_47_FILL">
                <path
                  fill="#2E2B2C"
                  d="M534.4,466.7l1.4-0.8c0.6-0.3,1-0.7,1.2-1.1c3.3-3.2,3.7-6.6,1.1-10.1c-0.1-0.1-0.1-0.2-0.1-0.5
                  c-2.4-1.2-5-1.6-7.7-1.1c-2,0.4-4.4,1.3-7.1,2.9c-1.8,4.6-1,7.8,2.6,9.8C528.4,467.2,531.2,467.5,534.4,466.7z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_48_FILL">
                <path
                  fill="#302E2F"
                  d="M467.5,451.8c-2.4,1.9-3.5,4.4-3.1,7.5c0.8,1.8,2.1,3.2,3.7,4c1.5,0.8,3.2,1.2,5.2,1.2
                  c3.5,0,6-2.1,7.5-6.1c-0.1-0.8-0.1-1.3,0-1.4c0.4-1.6,0.2-2.9-0.5-3.9c-0.6-0.8-1.8-1.5-3.4-2l-1.2-0.5
                  C472.7,449.6,469.9,450,467.5,451.8z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_50_FILL">
                <path
                  fill="#383637"
                  d="M255.5,454c-0.1,0.8-0.4,2.1-0.9,3.7c-0.3,1.5-0.3,2.8,0.1,3.9c1.1,3.1,3.6,5.3,7.6,6.4
                  c4,1.2,7.2,0.7,9.9-1.3c0.5-0.4,1-0.9,1.5-1.7c0.6-0.8,1.1-1.4,1.4-1.8c0.9-1.2,1.5-2.2,1.6-3c0-0.4-0.2-0.8-0.5-1.2
                  c-0.4-0.3-0.8-0.5-1.2-0.6c-0.7-0.1-1.5,0.1-2.2,0.5c-0.4,0.3-1.1,0.7-1.9,1.2c-2.6,1.4-4.8,1.8-6.6,1
                  c-1.9-0.7-3.3-2.5-4.3-5.2c-0.7-0.9-1.1-1.4-1.4-1.6c-0.6-0.5-1.4-0.6-2.2-0.4C256,454,255.8,454,255.5,454z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_52_FILL">
                <path
                  fill="#3C3C3E"
                  d="M260.2,448.7c-1.7,0.4-2.9,0.8-3.4,1.4c-0.8,0.8-1,2-0.7,3.8c0.6,0.8,1,2.1,1.2,4
                  c0.6,0.2,1.2,0.1,1.8-0.2c0.6-0.5,1-0.9,1.3-1.2c2-1.8,4.1-2.7,6.1-2.6c2,0.1,4,1,6.1,2.9c0.2,0.5,0.8,1,1.6,1.5
                  c0.9,0.5,1.5,1,1.8,1.4v0.8c1-0.1,1.5-0.6,1.5-1.6c0-1.2,0.1-1.9,0.4-2.1c0.3-0.7,0.1-1.5-0.8-2.3c-0.9-0.9-1.2-1.6-1.1-2.2
                  l0,0c-0.5-2.7-1.2-4.3-1.9-4.8s-2.3-0.4-4.6,0.3C267.6,447.6,264.5,447.9,260.2,448.7z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_59_FILL">
                <path
                  fill="#535456"
                  d="M275.9,460.4l-0.9,2.8c2.3-1.5,3.2-3.7,2.8-6.5L275.9,460.4z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_106_FILL">
                <path
                  fill="#D5D7D7"
                  d="M-72.4,30.9l-0.5,0.5c0.1,0.1,0.3,0.3,0.6,0.5c0.1,0,0.3-0.2,0.6-0.5L-72.4,30.9z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_107_FILL">
                <path
                  fill="#D5D7D7"
                  d="M-75,27.8c0,0.1-0.1,0.2-0.2,0.3c0,0.4,0.2,0.5,0.6,0.4c0.2,0,0.2-0.1,0.2-0.2
                  C-74.4,27.9-74.6,27.8-75,27.8z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_133_FILL">
                <path
                  fill="#F6F6F7"
                  d="M574.1,460.5c1.8-1,2.5-2.2,2.2-3.7c-0.2-1-0.5-1.8-0.8-2.3c-0.4-0.8-1-1.4-1.8-1.8
                  c-1-0.6-1.7-1-2.2-1.2c-0.8-0.3-1.6-0.1-2.4,0.5c-0.6,0.4-1.5,0.5-2.6,0.1c-1.6-0.3-3.1-0.1-4.7,0.6c-1,0.4-2.3,1.2-3.9,2.3
                  c-1.4,1-2.1,2.5-2,4.5c0.1,2,0.8,3.3,2.2,4.1c2.5,1.4,4.8,1.7,6.8,1C567.7,463.6,570.8,462.2,574.1,460.5z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_137_FILL">
                <path
                  fill="#E1E2E2"
                  d="M500.8,463l2-0.2c1.6-0.3,2.5-1,2.6-2.1c0.2-1.2-0.1-2.1-0.9-2.9c-0.9-0.8-2-0.9-3.5-0.1
                  c-0.8,0.4-1.4,0.7-1.8,1c-0.7,0.4-1.2,0.8-1.6,1.3c-1,1.3-0.6,2.2,1,2.8C499.1,462.9,499.8,463,500.8,463z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_138_FILL">
                <path
                  fill="#D5D6D6"
                  d="M533.9,459.7c0.4-0.2,0.8-0.5,0.9-0.9c0.2-0.4,0.2-0.9,0-1.4c-0.1-0.3-0.4-0.5-0.8-0.6
                  c-0.5,0-0.8,0-0.9,0c-1.2,0-2.2,0.1-2.9,0.3c-0.9,0.3-1.6,0.9-2.1,1.7c-0.2,0.2-0.2,0.5-0.1,0.8c0.1,0.3,0.4,0.5,0.7,0.7
                  c0.8,0.4,1.7,0.5,2.7,0.3C531.9,460.5,532.8,460.2,533.9,459.7z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_139_FILL">
                <path
                  fill="#E7E7E7"
                  d="M472.1,458.5c2.8,0,4.3-0.7,4.5-2c0-0.6-0.4-1.2-1.3-1.8c-0.9-0.7-1.7-1-2.5-1c-0.7,0-1.5,0.4-2.3,1.1
                  c-0.9,0.7-1.3,1.4-1.3,1.9C469.4,458,470.4,458.6,472.1,458.5z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_140_FILL">
                <path
                  fill="#F6F7F8"
                  d="M257.3,457.8c1.1,2.8,2.8,4.7,5.2,5.6c2.4,1,5,0.9,7.8-0.3c0.8-0.3,1.6-0.9,2.5-1.8
                  c1.3-1.2,2-1.9,2.1-2c0.4-1.1,0.6-1.8,0.6-2.2c0-0.9-0.3-1.6-0.9-2.2c-3.2-3.8-6.8-4.8-10.8-3.1c-0.4,0.2-1,0.3-1.8,0.3
                  c-2.6,0.2-4,1.5-4,4c0,0.2-0.1,0.5-0.2,0.8C257.7,457.2,257.5,457.5,257.3,457.8z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_141_FILL">
                <path
                  fill="#535456"
                  d="M275,459.4l0.9,0.1c0-1.2,0-2,0-2.4c-0.2-0.9-0.6-1.6-1.2-2.2C275.2,456.3,275.3,457.8,275,459.4z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_167_FILL">
                <path
                  fill="#322F30"
                  d="M212.2-32c-1.5-0.2-3.1-0.2-4.7,0C209.1-31,210.7-31,212.2-32z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_168_FILL">
                <path
                  fill="#322F30"
                  d="M201.9-32.1c-1.2-0.2-2.5-0.2-3.8,0C199.4-31.1,200.7-31.1,201.9-32.1z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_169_FILL">
                <path
                  fill="#322F30"
                  d="M219.6-31.9l-3-0.4c-0.2,0-0.4,0-0.7,0.1C217.1-31.2,218.3-31.1,219.6-31.9z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_190_FILL">
                <path
                  fill="#3E3E3E"
                  d="M477.3-33.9c-0.3-0.1-0.6-0.1-1,0c0.4,0.7,1,1.2,1.7,1.5c0.6,0.2,1.3,0.3,2.3,0.3c4.7,0,7.5,0,8.4,0
                  c0.9,0,1.4-0.1,1.6-0.2c0.6-0.2,1-0.7,1.3-1.5c-2.3-0.1-3.9-0.1-5-0.1c-1.9,0-3.5,0.1-4.8,0.3c-1.1,0.2-1.9,0.3-2.3,0.2
                  C478.6-33.3,477.9-33.5,477.3-33.9z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_201_FILL">
                <path
                  fill="#CBCCCE"
                  d="M114.1,442.3c0.1,0,0.3-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.2-0.5c-0.1-0.2-0.4-0.2-0.9-0.2
                  c-0.3,0-0.5,0.1-0.6,0.1c-0.2,0.1-0.3,0.3-0.2,0.6C113.3,442.1,113.6,442.2,114.1,442.3z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_204_FILL">
                <path
                  fill="#CFD1D2"
                  d="M-68.6,372.4c0.5-1.9,0.7-3.2,0.7-3.7c0-0.5-0.2-1.5-0.7-2.8V372.4z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_205_FILL">
                <path
                  fill="#CFD1D2"
                  d="M-68.7,377.3c-0.4,0.2-0.5,0.6-0.3,1.1c0.2,0.5,0.3,0.7,0.4,0.7c0.4,0,0.6-0.2,0.6-0.8
                  C-68.2,377.7-68.4,377.4-68.7,377.3z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_207_FILL">
                <path
                  fill="#302D2D"
                  d="M290-30.2c0.9,0.5,1.9,0.8,3.2,0.9c0.7,0,1.9,0,3.4,0c0.9-0.1,2.2-0.2,4-0.1c1.6-0.1,2.8-0.7,3.5-1.7
                  c-0.8-0.3-1.9-0.5-3.3-0.5c-1.7-0.1-2.9-0.2-3.4-0.2c-1.6,0.6-3.1,0.6-4.5,0h-2L290-30.2z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_210_FILL">
                <path
                  fill="#302D2D"
                  d="M309.6-30.2c0.3,0,0.6,0,1.1-0.1c0.4-0.1,0.7-0.4,0.8-0.8c-1.2-0.7-2.5-0.7-3.8,0H305
                  c0.6,0.4,1.4,0.7,2.2,0.8C307.7-30.2,308.5-30.2,309.6-30.2z"
                />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_211_FILL">
                <path fill="#322F30" d="M297.4-31.9l-4.5,0C294.3-31,295.8-31,297.4-31.9z" />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_213_FILL">
                <path fill="#322F30" d="M311.5-31.1c-1.3-0.8-2.5-0.8-3.8,0H311.5z" />
              </g>
            </g>
          </g>
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_214_FILL">
                <path fill="#322F30" d="M228.1-31.9h-3.6C225.7-31.2,226.9-31.2,228.1-31.9z" />
              </g>
            </g>
          </g>
          <path
            fill="#292728"
            d="M593.6,286.8c-0.5-2.7-0.6-4.9-0.4-6.5c0.1-2.3,0.1-5.7-0.1-10.2c-0.1-4.5-0.1-7.9-0.1-10.1
            c0-24.1,0-42.2,0-54.3c0-21.4,0.2-39.5,0.5-54.3c0-0.7,0.2-4,0.5-9.8c0.2-4,0.2-7.2-0.1-9.7c-0.6-5.6-0.8-12.9-0.8-21.9
            c0-11.3,0-18.6-0.2-21.8l-0.1-2.2c-0.7-5.4-1-11.7-1-18.8c0-0.6,0.2-6.9,0.5-18.9l-0.1-1.3l0.4-66.9c0-2.3,0.2-3.9,0.7-4.9
            l0.2-3.4c0.9-1.6,1.1-3.3,0.5-5.1c-0.3-0.9-1.2-2.4-2.6-4.5c-0.5-0.7-1-1.2-1.5-1.4c-0.8-0.3-1.5,0-2.2,0.9
            c-0.4,0.3-0.8,0.5-1.4,0.6c-0.7,0-1.2,0.1-1.6,0.2c-0.3,0.1-2.1,0.2-5.2,0.5c-2.1,0.2-3.7,0.7-4.9,1.5c-4.3,0.2-7.6,0.3-9.8,0.3
            c-8.9,0.1-15.5,0.1-19.9,0.2c-7.8,0.1-14.4,0.2-20,0.5l-34.6-0.1l-13.1,0.9c-0.1,0.4-0.1,0.6,0,0.8c-0.3-0.2-0.6-0.5-0.9-0.8
            l-43,0c-7.8,0.6-16.5,0.7-26.2,0.1c-4.1,0.5-9.1,0.8-15,0.8c-6.7-0.1-11.7-0.1-15,0c-4.4-1.4-9.8-2.1-16-2.3
            c-7.2,0.1-12.6,0.2-16.2,0.1c-1.7,0-2.9,0.1-3.7,0.4c-3.8,1.2-8.1,2-13,2.2c-3,0.1-7.4,0.1-13.1-0.2c-1.2,0.2-2.2,0.2-2.8,0.2
            c-6.5-0.3-16.3-0.3-29.4-0.2c-3.9,0-12.8,0-26.6-0.2c-13.8,0.3-26.9,0.3-39.2,0l-0.4,0.7c0.1,0.2,0.2,0.4,0.3,0.6
            c-0.4-0.1-0.7-0.3-1-0.5c-1.2-0.2-2.4-0.2-3.7,0.1c-1.5,0.7-3.1,0.7-4.7,0l-5.6-0.1c-1.3,0.8-2.5,0.8-3.8,0
            c-1.4-0.3-2.6-0.2-3.7,0.1c-2.3-0.1-4-0.1-5.1-0.1l-31.2,0.2c-0.3,0.2-0.4,0.4-0.4,0.7c0,0-0.1,0-0.1,0l-37.1,0.1
            c-0.2-0.4-0.4-0.8-0.7-1.2c-1.6-0.8-3.8-1.1-6.8-0.9c-2,0.2-8.3,0.8-18.9,2L81.6-31c-0.3,0-4,0-11.1,0c-4.4,0-8.1,0.2-11,0.6
            c-1-0.2-1.6-0.2-1.9-0.2l-91.1,0.3c-1.7,0-3.1-0.1-4.2-0.3c-1.5-0.3-2.7-0.9-3.8-1.7c-1.1-0.9-2.4-1-4-0.5c-1.3,0.4-2.3,0.7-3,0.9
            c-1.1,0.4-2,0.8-2.7,1.2c-2,1.3-4.2,1.8-6.6,1.3l-8.5-0.9c-0.8,0.2-1.4,0.5-1.8,1c-0.4,0.5-0.5,1.1-0.1,1.8c0.3,0.5,0.2,1-0.2,1.5
            c-0.5,0.6-0.7,1-0.7,1.2c-0.4,0.6-0.6,1.5-0.7,2.7c-0.1,1.5-0.2,2.4-0.3,2.8c0.5,5.1,0.3,10-0.5,14.8c-0.1,0.8-0.1,1.7,0.2,2.7
            c0.6,2.2,0.8,5.1,0.6,8.6c-0.2,3.5-0.3,9.8-0.3,18.7l0,22.8c0.3,3.7,0.4,7.1,0,10c0.4,2.8,0.5,6,0.2,9.8c0.2,0.6,0.3,1.3,0.3,2.2
            c0,0.5,0,1.3,0,2.3c0.3,4.5,0.2,10.8-0.3,18.9c-0.5,8.8-0.7,15.1-0.7,18.8c0,1.9-0.1,6.3-0.4,13.2c-0.7,13.2-0.7,28.1,0,44.7
            c0.1,1.8,0.1,3.2,0.1,4c-0.1,1.5-0.3,2.8-0.7,4c0.5,5.2,0.9,11.2,1,18c0,2.1,0.1,8.1,0.1,18c0,2.3,0,5.8-0.1,10.5
            c0,4.1,0,7.6,0.2,10.5c1.1,15.5,1,29-0.3,40.5c-0.1,1.1,0.1,2.4,0.6,4c-0.2,3-0.1,6.8,0.1,11.5c0.3,6.1,0.4,9.9,0.4,11.5v58.8
            c0,2.2,0,3.4,0.1,3.7c0.8,5.8,1.2,12.2,1.1,19.3c0,4.8-0.2,11.2-0.6,19.3c-0.4,7.2,0.1,13.8,1.3,19.8c0,0.1,0,1.1,0,2.9
            c0,1.1-0.2,2.1-0.5,2.8c-1.5,1.1-2.4,2.4-2.9,3.8c0,0,0,1.1-0.1,3.2c0,1.3,0,2.3,0,3.1c0.1,1.5,0.4,2.5,1,3
            c0.5,0.5,1.6,0.7,3.1,0.7c0.8,0,2.1-0.1,3.7-0.2c1.5,0,2.7,0,3.7,0.2h1.9c0.6,0.4,1.3,0.7,2.1,0.9c0.3,0.1,1,0.2,2.2,0.4
            c7.1,0,23,0.1,47.7,0.5c19.7,0.3,35.6,0.2,47.7-0.2c0.8,0.4,2,0.5,3.5,0.5c1.7-0.1,2.9-0.1,3.5,0c2.4-0.2,5.6-0.3,9.7-0.5
            c4.7-0.2,7.9-0.3,9.6-0.4c3.1-0.2,7.9-0.1,14.5,0.2c6.3,0.3,11.2,0.3,14.5,0c7.4-0.6,11.3-0.9,11.9-0.9c7.8-0.1,17.2-0.1,28.2-0.1
            c6.3,0,15.7,0,28.2,0c5.5,0,9.3,0,11.5,0.1c4.3,0.2,8,0.6,11.3,1.2c2.9-0.3,5.6-0.3,8.2,0.1c2.3,0.3,5.3,0.2,9.1-0.4
            c4.4-0.7,7.4-1,9-1c23.1,0,37,0,41.7,0c1.1,0,3.2,0.3,6.2,0.8c2.6,0.5,4.7,0.6,6.2,0.4c3.1-0.5,6.9-0.8,11.4-0.9
            c2.6-0.1,6.4-0.1,11.4-0.1c7.7-0.2,16.5-0.2,26.6-0.1c3,0.1,11.8,0.3,26.5,0.7c24.3,0.6,47.2,0.4,68.7-0.6
            c11.7-0.6,18.5-0.9,20.3-1c7.7-0.3,14.4-0.3,20.2-0.2c0.5,0,1.3,0,2.4,0c0.9,0.1,1.6,0.3,2.2,0.7c5.1,0.8,9.7,0.7,13.8-0.3h1
            c3.2,0.8,7,1.3,11.2,1.6c1.5,0.1,5.3,0.3,11.3,0.5c14.9,0.6,29.2,0.4,42.9-0.8c1.5-0.1,3.7-0.2,6.7-0.2c2.6-0.1,4.8-0.5,6.6-1.1
            c2.7-0.1,6.8-0.3,12.2-0.7c4.7-0.2,8.8-0.3,12.2-0.2c5.2-0.3,9.2-2.2,12-5.5c2.3-0.9,3.3-2.7,3-5.4c-0.2-1.5-0.2-2.8,0.2-3.9
            c0.8-2.3,1.3-4.8,1.6-7.7c0.2-1.8,0.3-4.4,0.4-7.8c-0.2-2-0.2-4.7-0.1-8.2c0.1-3.9,0.1-6.6,0-8.2c-0.1-1.7-0.2-3-0.4-3.8
            c-0.3-1.3-0.9-2.4-1.9-3.2c-0.2-8.1-0.4-13.9-0.4-17.4c-0.1-6.5,0.1-12.2,0.3-17.4c0.8-0.6,1.4-1.4,1.8-2.3
            c0.3-0.7,0.4-1.7,0.5-2.9c0.1-3.2,0.1-5.6,0.1-7.2c0-2.2,0-9.8,0-23c-0.1-9.3,0.1-17,0.5-22.9C594.4,292.1,594.1,290,593.6,286.8z
             M584.6-18.9c-0.1,18.9-0.1,59.7,0,122.6c0,50.7-0.2,91.6-0.7,122.6c-0.4,25.1-0.5,55.8-0.4,92.1c0.1,20.5,0.2,51.2,0.3,92
            c0,6-0.7,11.6-2,16.7c-0.6,2.3-1.5,3.8-2.6,4.7s-2.9,1.4-5.4,1.5l-4.2,0c-31.6,0.1-116.6,0.1-255-0.1
            c-104.3-0.1-189.3,0.2-255.1,0.9c-17.2-0.1-30.2,0-38.8,0.1c-9.6,0.2-25-0.1-46.3-0.7c-2.4-0.1-6.8,0-13.4,0.1
            c-5.6,0.1-10,0.1-13.3-0.2c-2.8-0.2-4.6-0.7-5.4-1.5c-0.8-0.8-1.2-2.5-1.2-5.2c-0.1-28.2-0.4-50.5-0.8-67.1
            c-0.3-12.7-0.4-33.8-0.3-63.2c0.1-27.1-0.1-48.2-0.6-63.3c-0.4-11.2-0.6-25.6-0.7-43.1c-0.1-24.2-0.2-38.6-0.2-43.2
            c-0.2-19.2-0.3-43-0.3-71.5c0.1-31.8,0.1-55.6,0.1-71.5c0-7.8-0.5-16-1.7-24.5c-0.2-0.4-0.3-0.9-0.4-1.2c1.5-0.9,3.1-1.4,4.8-1.7
            c2.1-0.3,4.6-0.3,7.6,0.2c6.2,1,12.9,1.2,20.1,0.5c4.2-0.4,9.2-0.6,15-0.7c3.3,0,8.3,0,14.9,0h58.1c1,0,2.5,0,4.5,0
            c1.7,0,3.2-0.2,4.5-0.5c0.6-0.2,1.6-0.4,3-0.6c0.2,0,0.3,0.1,0.5,0.1c0.2,0,1.6,0,4.3,0c8.9,0,22.3,0,40.2,0
            c15.8,0,29.2-0.2,40.1-0.8c5.4-0.3,12.5-0.4,21.1-0.3c11.7,0.1,18.7,0.1,21,0.1c0.8,0,2.1,0,3.8-0.1c1.4-0.2,2.5-1,3.1-2.2
            c0,0.2,0.1,0.4,0.3,0.7c1.3,1,3,1.6,5,1.7c1.2,0.1,2.9,0,5.3-0.1c41.8-0.1,68.2-0.2,79.2-0.3c29.8-0.2,56.2-0.6,79.2-1.1
            c42.9-1,89.2-1.4,138.9-1.3c2.1,0,3.6,0,4.6-0.2c1.1-0.1,1.8-0.2,2.3-0.3c0.8-0.3,1.4-0.7,1.9-1.4c0.1-0.4,0.1-0.8,0.1-1.1
            c0,0,0.1,0,0.1,0c0.6,0.9,1.5,1.5,2.7,1.8C523-29,524-29,525.6-29c22.1,0.2,38.7,0.2,49.8,0c2.7-0.1,4.5-0.2,5.6-0.3
            c0.8,0.3,1.5,0.7,2.1,1.1c0.9,1.2,1.4,2.8,1.5,4.5C584.6-23.6,584.6-22,584.6-18.9z"
          />
          <g transform="matrix( 1, 0, 0, 1, 0,0) ">
            <g>
              <g id="Cert_Border_0_Layer0_0_MEMBER_218_FILL">
                <path
                  fill="#B3B5B6"
                  d="M594.4,162.5L594.4,162.5c-0.3-0.4-0.5-0.6-0.5-0.6c-0.2-0.2-0.5-0.2-0.8-0.1c-0.2,0.1-0.2,0.2-0.2,0.4
                  c0.1,0.3,0.3,0.5,0.7,0.5C593.7,162.7,594,162.6,594.4,162.5z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>

    <a class="modal-close-button certificate" @click="closeModal" v-html="buttonClose"></a>

    <div class="cert-print-wrapper">
      <a class="cert-print" @click="printModal">PRINT</a>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import btnClose from 'assets/svg/btn-close.svg';

export default {
  data() {
    return {
      buttonClose: btnClose
    };
  },

  computed: {
    ...mapState('student', {
      studentName: ({ firstName, lastName }) =>
        (lastName ? `${firstName} ${lastName}` : firstName)
    })
  },

  methods: {
    ...mapMutations('application', ['setModal']),
    printModal() {
      window.print();
    },
    closeModal() {
      this.setModal(undefined);
    }
  }
};
</script>

<style lang="scss" scoped>
.certificateContents {
  position: relative;
  margin: 0 auto;
  width: 875px;
}
.cert-print-wrapper {
  display: block;
  text-align: center;
  position: relative;
}
.cert-print {
  color: white;
  margin: 10px auto 0 auto;
  display: inline-block;
  text-align: center;
  padding: 5px 15px;
  border-radius: 5px;
  background-color: green;
  font-family: "hwtfutura-bold";
  position: relative;
  bottom: 30px;
}
@media print {
  .certificateContents {
    transform: scale(1.15) translateX(-15px) rotate(-90deg);
  }
  body .contentPanel {
    width: 100%;
    height: auto;
    border: none;
    position: static;
    border-image-source: url("./../../assets/images/spacer.gif");
    border-image: url("./../../assets/images/spacer.gif");
    border-image-slice: 0 0 fill;
    border-image-width: 0;
    border-image-outset: 0;
    border-image-repeat: none;
    border-style: none;
    margin: 0 auto;
    background-color: transparent;
    text-align: center;
    overflow: auto;
    left: auto;
    top: auto;
    -webkit-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-tarnsform: translate(0, 0);
    transform: translate(0, 0);
  }
  .activity-instructions,
  .activity-intro,
  .keyboardid,
  .textfield-container,
  .kwtToolbar,
  .debugPanel,
  .keyboard,
  .brain,
  .themeScreen,
  .modal-close-button.certificate,
  .cert-print-wrapper,
  .button-print {
    display: none;
  }
  .modal-mask {
    background-color: transparent;
  }
}
</style>
